import api, { apiVendas } from '~/services/api';
import {
  API_BASE_URL,
  API_LOCAL_URL,
  TIPO_DOCUMENTO,
  APPLICATION_MODE,
  API_VENDAS_URL
} from '~/constants';

class PdvService {
  _strategy = null;

  setStrategy(tipoDocumento) {
    if (tipoDocumento === TIPO_DOCUMENTO.ORCAMENTO) {
      this._strategy = new OrcamentoServiceStrategy();
    } else if (tipoDocumento === TIPO_DOCUMENTO.PEDIDO) {
      this._strategy = new PedidoServiceStrategy();
    } else if (tipoDocumento === TIPO_DOCUMENTO.DOCUMENTOSAIDA) {
      this._strategy = new DocumentosaidaServiceStategy();
    }
  }

  async enviarDocumento(payload) {
    if (!this._strategy) {
      throw new Error('Informar tipo de documento');
    }

    return this._strategy.store(payload);
  }

  async getDocumento(payload) {
    if (!this._strategy) {
      throw new Error('Informar tipo de documento');
    }

    return this._strategy.get(payload);
  }
}

class OrcamentoServiceStrategy {
  async store({ isOnline, ...payload }, opts) {
    console.log('OrcamentoServiceStrategy.store', {
      data: new Date(),
      payload
    });
    const id = isOnline ? payload?.id : payload?._id;
    return isOnline
      ? id
        ? api.put(`${API_BASE_URL}/v1/faturamento/orcamento/${id}`, payload)
        : api.post(`${API_BASE_URL}/v1/faturamento/orcamento/`, payload, opts)
      : id
      ? api.put(`${API_LOCAL_URL}/faturamento/orcamento/${id}`, payload)
      : api.post(`${API_LOCAL_URL}/faturamento/orcamento/`, payload);
  }

  async get({ isOnline, ...payload }) {
    console.log('OrcamentoServiceStrategy.get', {
      data: new Date(),
      payload,
      isOnline
    });

    return api.get(
      !isOnline && payload?._id
        ? `${API_LOCAL_URL}/faturamento/orcamento/${payload?._id}`
        : `${API_BASE_URL}/v1/faturamento/orcamento/${payload?.id}`
    );
  }
}

class PedidoServiceStrategy {
  async store({ isOnline, ...payload }, opts) {
    console.log('PedidoServiceStrategy.store', {
      data: new Date(),
      payload,
      isOnline
    });

    const id = isOnline ? payload?.id : payload?._id;
    return isOnline
      ? id
        ? apiVendas.put(`/v1/faturamento/pedido/${id}`, payload)
        : apiVendas.post(`/v1/faturamento/pdv/pedido`, payload, opts)
      : id
      ? api.put(`${API_LOCAL_URL}/faturamento/pedido/${id}`, payload)
      : api.post(`${API_LOCAL_URL}/faturamento/pedido/`, payload);
  }

  async get({ isOnline, ...payload }) {
    console.log('PedidoServiceStrategy.get', {
      data: new Date(),
      payload,
      isOnline
    });

    return api.get(
      !isOnline && payload?._id
        ? `${API_LOCAL_URL}/faturamento/pedido/${payload?._id}`
        : `${API_BASE_URL}/v1/faturamento/pedido/${payload?.id}`,
      {
        // query URL without using browser cache
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0'
        }
      }
    );
  }
}

class DocumentosaidaServiceStategy {
  async store({ isOnline, ...payload }, opts) {
    console.log('DocumentosaidaServiceStategy.store', {
      data: new Date(),
      payload,
      isOnline
    });
    const id = isOnline ? payload?.id : payload?._id;
    payload = this.sanitizeDocumentosaidaPayload(payload)
    return isOnline
      ? id
        ? apiVendas.put(`/v1/faturamento/documentosaida/${id}`, payload)
        : apiVendas.post(`/v1/faturamento/pdv/documentosaida`, payload, opts)
      : id
      ? api.put(`${API_LOCAL_URL}/faturamento/documentosaida/${id}`, payload)
      : api.post(`${API_LOCAL_URL}/faturamento/documentosaida/`, payload);
  }
  
  sanitizeDocumentosaidaPayload(payload) {
    payload.itens?.forEach(item => {
      if (item.fisModeloTributacaoIbsCbsIs) {
        delete item.fisModeloTributacaoIbsCbsIs.situacaoTributariaIbsCbsList;
        delete item.fisModeloTributacaoIbsCbsIs.classificacaoIbsCbsList;
      }
      delete item.impostoIbsCbsClassificacaoEnumList
      delete item.impostoIbsCbsClassificacaoList
      delete item.impostoIbsCbsSituacaoEnumList
      delete item.impostoIbsCbsSituacaoList
    });
    return payload
  }

  async get({ isOnline, ...payload }) {
    console.log('DocumentosaidaServiceStategy.get', {
      data: new Date(),
      payload,
      isOnline
    });

    return api.get(
      !isOnline && payload?._id
        ? `${API_LOCAL_URL}/faturamento/documentosaida/${payload?._id}`
        : `${API_BASE_URL}/v1/faturamento/documentosaida/${payload?.id}`
    );
  }
}

export default new PdvService();
